/* Libraries */
import cn from 'classnames';
import Link from 'next/link';
import get from 'lodash/get';

/* Utils */
import { skuPath } from '@constants/paths';
import { noop } from '@utils/event';
import { SegmentTrackingAction } from '@integrations/segment/search';

/* Components */
import { Icon, Grid } from 'ht-styleguide';

/* Constants */
import { getServiceType } from '../constants';

// Styles
import styles from '../searchbar.module.scss';

/* Types */
type ServiceResultsProps = {
  iconClick: $FixMe;
  getItemProps: $FixMe;
  serviceResults: any[];
  searchTerm?: string;
};
const ServiceResults = ({ serviceResults = [], iconClick = noop, getItemProps, searchTerm }: ServiceResultsProps) => {
  if (!get(serviceResults, 'length', false)) return null;

  return (
    <>
      <p className="caption marginTop-medium paddingX-small1 n700" data-testid="search-services-results-count">
        SERVICES ({serviceResults.length})
      </p>
      {serviceResults &&
        serviceResults.map(service => {
          const serviceType = getServiceType(service);
          const onClick = () => {
            SegmentTrackingAction.search({
              searchTerm,
              clickedItem: 'service',
              attributes: service,
            });

            iconClick();
          };
          return (
            <div key={service.id} onClick={onClick} data-testid="search-services-results">
              <Grid.FullWidth classes={styles.categoryContainer}>
                <Grid.Row classes={styles.customRow}>
                  <Link
                    href={skuPath(service.seo_name.raw)}
                    {...getItemProps({
                      key: service.id.raw,
                      item: service,
                    })}
                    className={cn('paddingX-small1', styles.clickContainer)}
                  >
                    <Grid.Column classes={cn('paddingY-small', styles.servicesColumnContainer)}>
                      <div className={styles.innerColumn}>
                        <p className={cn('caption paddingBottom-tiny', styles.services)}>{serviceType}</p>
                        <div className={cn('h6 paddingBottom-tiny', styles.name)}>{service.name.raw}</div>
                      </div>
                      <Icon name="chevron-right" className={styles.chevron} />
                    </Grid.Column>
                  </Link>
                </Grid.Row>
              </Grid.FullWidth>
            </div>
          );
        })}
    </>
  );
};

export default ServiceResults;
